import React from 'react'
import { WhyManafithData } from '../../constants';
import {BackgroundGradient} from "../ui/Backgroundgradient";
import { useStateContext } from '../../context/ContextProvider';

const WhyManafith = () => {
    const { currentLang } = useStateContext();
    
    // دالة لتحويل النص مع \n إلى عناصر JSX مع فواصل أسطر
    const formatDescription = (text) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line.trim() && (
                    <>
                        {line.trim().startsWith('•') ? (
                            <div className="flex items-start rtl:mr-4 ltr:ml-4 mb-2">
                                <span className="block mt-1 mr-2 rtl:ml-2 rtl:mr-0">•</span>
                                <span>{line.trim().substring(1)}</span>
                            </div>
                        ) : (
                            <p className="mb-4 last:mb-0">{line.trim()}</p>
                        )}
                    </>
                )}
            </React.Fragment>
        ));
    };

    return (
        <div className={`mt-12  md:mt-16 lg:mt-20 flex flex-col lg:flex-row items-center justify-between gap-8 container`}>
            <BackgroundGradient 
             
                className="rounded-[22px] w-full flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10 lg:gap-12 p-4 sm:p-10 bg-light-secondary dark:bg-dark-secondary"
            >
      
                <div className="space-y-4 w-full">
                    <h2 className="h4 text-light-title dark:text-dark-title">
                        {currentLang === "ar" ? WhyManafithData.Main_title_Ar : WhyManafithData.Main_title_En}
                    </h2>
                    <div className="  md:body-2 body-1  text-light-subtitle dark:text-dark-subtitle leading-relaxed md:leading-loose">
                        {formatDescription(currentLang === "ar" ? WhyManafithData.Main_description_Ar : WhyManafithData.Main_description_En)}
                    </div>
                </div>
            </BackgroundGradient>
            
            <BackgroundGradient   
          
                className="rounded-[22px] w-full flex flex-col items-center justify-between gap-8 md:gap-10 lg:gap-12 p-4 sm:p-10"
            >
                <div className="space-y-4 w-full">
                    <h2 className="h4 text-light-secondary dark:text-dark-title">
                        {currentLang === "ar" ? WhyManafithData.Second_title_Ar : WhyManafithData.Second_title_En}
                    </h2>
                    <div className=" md:body-2 body-1  text-dark-subtitle leading-relaxed md:leading-loose">
                        {formatDescription(currentLang === "ar" ? WhyManafithData.Second_description_Ar : WhyManafithData.Second_description_En)}
                    </div>
                </div>
            </BackgroundGradient>
        </div>
    );
}

export default WhyManafith;